module.exports = __webpack_public_path__ + "img/bio-6.0c28124.jpg";